import { Portfolio } from '@/sdk/entities/portfolio';
import { useStore } from 'vuex';

export function getPortfolioApr(portfolio: Portfolio): number | undefined {
  const store = useStore();
  const portfolioFarm = store.state.farming.lp[portfolio.lpTokenAddress];
  return portfolioFarm ? portfolioFarm.printIPR : portfolio.printIPR;
}
